export default __webpack_public_path__ + "media/images/icons/icon-select-848439ee5d370b3f4bd1aadeb6217d6f.svg";